import { createFileRoute, notFound, useNavigate } from '@tanstack/react-router';
import {
  VIEW_EXPERIMENTS_PAGE,
  VIEW_EXPERIMENTS_V2_PAGE,
} from '../../../../utils/permissions';
import useDatadogTracking from '../../../../hooks/useDatadogTracking';
import { useEffect, useState } from 'react';
import SampleSetsList from '../../../../pages/experiments/SampleSetsList';
import CreateSampleSetWorkflowDialog from '../../../../components/dialogs/CreateSampleSetWorkflowDialog';
import { sampleSetsInfiniteQueryOptions } from '../../../../services/queries';

export const Route = createFileRoute('/_authenticated/_navbar/experiments/')({
  beforeLoad: ({ context }) => {
    if (
      !context.auth.hasPermission(VIEW_EXPERIMENTS_PAGE) &&
      !context.auth.hasPermission(VIEW_EXPERIMENTS_V2_PAGE)
    ) {
      throw notFound();
    }
  },
  loader: ({ context }) => {
    // Prefetch the first page with empty search query
    context.queryClient.prefetchInfiniteQuery(
      sampleSetsInfiniteQueryOptions(context.auth.hasPermission, '')
    );
  },
  component: Experiments,
});

function Experiments() {
  const navigate = useNavigate();
  const { trackPageView } = useDatadogTracking();

  const [showCreateSampleSetDialog, setShowCreateSampleSetDialog] =
    useState(false);

  useEffect(() => {
    trackPageView('experiments-page');

    // Prevent body scrolling when this component is mounted
    document.body.style.overflow = 'hidden';

    // Restore scrolling when component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [trackPageView]);

  return (
    <>
      <SampleSetsList
        onCreateSampleSet={() => setShowCreateSampleSetDialog(true)}
      />

      {showCreateSampleSetDialog && (
        <CreateSampleSetWorkflowDialog
          onClose={() => setShowCreateSampleSetDialog(false)}
          onSubmit={(sampleSet) => {
            setShowCreateSampleSetDialog(false);
            navigate({
              to: '/experiments/$sampleSetId',
              params: { sampleSetId: sampleSet.id },
            });
          }}
          open={showCreateSampleSetDialog}
        />
      )}
    </>
  );
}
